// extracted by mini-css-extract-plugin
module.exports = {"colors":"\"css/base/colors.css\"","grey-font-color":"#000000","header":"_1K0FYsn","bordered_header":"_2l91aul _1K0FYsn"};